import React from "react";

// Lazy load rich text editor ...
export const InstructionHtmlInput = React.lazy(() => import("./InstructionHtmlInput_"));
